var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('Header',{attrs:{"bgColor":_vm.isScroll ? '#fff' : 'transparent'}}),_vm._t("default"),_c('BottomBtn')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }